import Cookies from "js-cookie";

const SESSION_TOKEN = "session";

export function removeSession() {
  return Cookies.remove(SESSION_TOKEN);
}

export function getSessionToken() {
  return Cookies.get(SESSION_TOKEN);
}

export function setSessionToken(accessToken: string) {
  Cookies.set(SESSION_TOKEN, accessToken, { sameSite: "none", secure: true });
}
